import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  prices: {}, // { BTCUSDT: { bid, ask, timestamp } }
};

const marketSlice = createSlice({
  name: "market",
  initialState,
  reducers: {
    setInitialPrices(state, action) {
      // action.payload = [{ symbol, bid, ask, timestamp, changePer }]
      for (let item of action.payload) {
        const { symbol, best_bid, best_ask } = item;
        state.prices[symbol] = {
          bid: best_bid,
          ask: best_ask,
          timestamp: Date.now(),
          changePer: 0,
        };
      }
    },
    updatePrice(state, action) {
      const { symbol, bid, ask, timestamp, changePer } = action.payload;
      state.prices[symbol] = { bid, ask, timestamp, changePer };
    },
  },
});

export const { updatePrice, setInitialPrices } = marketSlice.actions;
export default marketSlice.reducer;
